/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/to_geohex.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Converts an input value to a `geohex` value.
 * A string will only be successfully converted if it respects the
 * `geohex` format, as described for the
 * geohex grid aggregation.
 *
 * @example
 * ROW string = "841f059ffffffff"
 * | EVAL geohex = TO_GEOHEX(string)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'to_geohex',
  signatures: [
    {
      params: [
        {
          name: 'field',
          type: 'geohex',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohex',
    },
    {
      params: [
        {
          name: 'field',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohex',
    },
    {
      params: [
        {
          name: 'field',
          type: 'long',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohex',
    },
    {
      params: [
        {
          name: 'field',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'geohex',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
